import React from 'react';
import { ResourceManager } from './components/ResourceManager';

const ApartmentsModule = () => (
  <ResourceManager
    table="apartments"
    title="Apartments"
    description="Sync apartment-specific content for marketing landing pages."
    columns={[
      { label: 'Name', accessor: 'name' },
      { label: 'Location', accessor: 'location' },
      { label: 'Units', accessor: 'units' },
      { label: 'Status', accessor: 'status' },
    ]}
    formFields={[
      { name: 'name', label: 'Name', placeholder: 'Nyinimu Heights II' },
      { name: 'location', label: 'Location', placeholder: 'Najjera' },
      { name: 'units', label: 'Units', type: 'number', placeholder: '48' },
      { name: 'status', label: 'Status', placeholder: 'Selling' },
      { name: 'hero_image', label: 'Hero Image URL', placeholder: 'https://...' },
      { name: 'description', label: 'Description', type: 'textarea' },
    ]}
    defaultValues={{
      name: '',
      location: '',
      units: '',
      status: 'Selling',
      hero_image: '',
      description: '',
    }}
    transformBeforeSave={(payload) => ({
      ...payload,
      units: Number(payload.units) || 0,
    })}
  />
);

export default ApartmentsModule;
